import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkillsComponent } from './skills.component';
import { RecordComponent } from './record.component';
import { ViewComponent } from './view.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'app/core/auth.guard';
import { PrepareGuard } from 'app/core/prepare.guard';
import { SharedModule } from 'app/shared/shared.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'involvement',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'view', pathMatch: 'full' },
                    { path: 'view', component: ViewComponent, data: { title: 'Involvement - View' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: 'record',
                        component: RecordComponent,
                        data: { title: 'Involvement - Record' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'skills',
                        component: SkillsComponent,
                        data: { title: 'Involvement - Skills' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
})
export class InvolvementModule {}
